import GenericApi from '../lib_react_frontend/utils/GenericApi.jsx';

export default (class Api extends GenericApi {
  /**
   * Realiza o login no sistema
   * @param {string} login O usuário.
   * @param {string} senha A Senha.
   * @param {string} email O email.
   */
  static async login(login, senha) {
    return await super.post("/login", { login, senha });
  }

  static async getDadosEmpresaFechamento(cnpj) {
    return await super.get(`/dados_empresa_fechamento?cnpj=${cnpj}`);
  }

  static async getEmpresaUsuario(usuario, filtro) {
    return await super.post("/get_empresa_usuario", { usuario, filtro });
  }
  static async getUsuarios(filtro) {
    return await super.post("/get_usuarios", { filtro });
  }
  static async getEmpresasNaoAdicionadas(empresasAdicionadas) {
    return await super.post("/get_empresas_nao_adicionadas", {
      empresasAdicionadas,
    });
  }
  //altera a senha do usuario logado
  static async setAlterarSenha(cod_usuario, senha_usuario, senha_atual) {
    return await super.post("/set_alterar_senha", {
      cod_usuario,
      senha_usuario,
      senha_atual,
    });
  }
});



// WEBPACK FOOTER //
// ./src/utils/Api.jsx